const TmpL013 = (page, section) => {
  const media = [];
  const images = [];
  const eMentors = [];
  const materials = [];
  const modifiedPage = {
    ...page
  };

  const parsedFeedback = [];

  const noFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case '0': {
        return pickInstructions('variation-1-');
      }
      case '1': {
        return pickInstructions('variation-5');
      }
      case '2': {
        return pickInstructions('variation-6');
      }
      case '3': {
        return pickInstructions('variation-13');
      }
      case '4': {
        return pickInstructions('variation-17');
      }
      case '5': {
        return pickInstructions('variation-21');
      }
      case '6': {
        return pickInstructions('variation-25');
      }
      case '7': {
        return pickInstructions('variation-29');
      }
    }
  };

  const lowFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case '0': {
        return pickInstructions('variation-2-');
      }
      case '1': {
        return pickInstructions('variation-6');
      }
      case '2': {
        return pickInstructions('variation-10');
      }
      case '3': {
        return pickInstructions('variation-14');
      }
      case '4': {
        return pickInstructions('variation-18');
      }
      case '5': {
        return pickInstructions('variation-22');
      }
      case '6': {
        return pickInstructions('variation-26');
      }
      case '7': {
        return pickInstructions('variation-30');
      }
    }
  };

  const midFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case '0': {
        return pickInstructions('variation-3-');
      }
      case '1': {
        return pickInstructions('variation-7');
      }
      case '2': {
        return pickInstructions('variation-11');
      }
      case '3': {
        return pickInstructions('variation-15');
      }
      case '4': {
        return pickInstructions('variation-19');
      }
      case '5': {
        return pickInstructions('variation-23');
      }
      case '6': {
        return pickInstructions('variation-27');
      }
      case '7': {
        return pickInstructions('variation-31');
      }
    }
  };

  const highFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case '0': {
        return pickInstructions('variation-4');
      }
      case '1': {
        return pickInstructions('variation-8');
      }
      case '2': {
        return pickInstructions('variation-12');
      }
      case '3': {
        return pickInstructions('variation-16');
      }
      case '4': {
        return pickInstructions('variation-20');
      }
      case '5': {
        return pickInstructions('variation-24');
      }
      case '6': {
        return pickInstructions('variation-28');
      }
      case '7': {
        return pickInstructions('variation-32');
      }
    }
  };

  page.content.item_feedback.forEach((feedback) => {
    const parsedFeedbackItem = {
      ...feedback
    };
    const noFeedback = noFeedbackInstructions(
      page.instructions,
      feedback.interaction_type
    );
    const lowFeedback = lowFeedbackInstructions(
      page.instructions,
      feedback.interaction_type
    );
    const midFeedback = midFeedbackInstructions(
      page.instructions,
      feedback.interaction_type
    );
    const highFeedback = highFeedbackInstructions(
      page.instructions,
      feedback.interaction_type
    );
    // add no completion feedback
    parsedFeedbackItem.incomplete_feedback_en =
      noFeedback.find((data) => data.course === 'Default')?.content || null;
    parsedFeedbackItem.incomplete_feedback_tl =
      noFeedback.find((data) => data.course !== 'Default')?.content || null;
    // add low completion feedback
    parsedFeedbackItem.low_feedback_en =
      lowFeedback.find((data) => data.course === 'Default')?.content || null;
    parsedFeedbackItem.low_feedback_tl =
      lowFeedback.find((data) => data.course !== 'Default')?.content || null;
    // add mid completion feedback
    parsedFeedbackItem.mid_feedback_en =
      midFeedback.find((data) => data.course === 'Default')?.content || null;
    parsedFeedbackItem.mid_feedback_tl =
      midFeedback.find((data) => data.course !== 'Default')?.content || null;
    // add high completion feedback
    parsedFeedbackItem.high_feedback_en =
      highFeedback.find((data) => data.course === 'Default')?.content || null;
    parsedFeedbackItem.high_feedback_tl =
      highFeedback.find((data) => data.course !== 'Default')?.content || null;

    parsedFeedback.push(parsedFeedbackItem);
  });

  modifiedPage.content.item_feedback = parsedFeedback;

  const image = {
    size: '900px X 900px',
    ...page.content.core.media,
    page: page.id,
    src: page.label.toLowerCase().replaceAll('-', '_') + '.jpg'
  };
  // add the media object to the media array
  media.push(image);
  images.push(image);

  modifiedPage.content.core.media = image;

  modifiedPage.content.core.media.src =
    page.label.toLowerCase().slice(0, -4).replaceAll('-', '_') +
    page.content.core.label.toLowerCase().replaceAll(' ', '_') +
    '.jpg';

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Inject page.id into each focus point if present
  if (page.content && Array.isArray(page.content.focus_points)) {
    page.content.focus_points.forEach((fp) => {
      fp.page = page.id;
    });
  }

  let jobAid = {
    page: page.id,
    section: section,
    type: 'job-aid',
    content: {
      jobaid_pdf_lead_en: page.content.core.jobaid_pdf_lead_en,
      jobaid_pdf_lead_tl: page.content.core.jobaid_pdf_lead_tl,
      jobaid_pdf: page.content.jobaid_pdf
    }
  };

  materials.push(jobAid);

  // Remove jobaid_pdf from the modified page, it's not needed in json
  delete modifiedPage.content.jobaid_pdf;

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: materials || [],
    eMentor: eMentors,
    focusPoints: page.content.focus_points || []
  };

  //   remove all instructions from the array that do not have label of "ins-default"
  modifiedPage.instructions = modifiedPage.instructions.filter(
    (ins) => ins.label === 'ins-default'
  );

  return { modifiedPage, metadata };
};

export default TmpL013;
